export default __webpack_public_path__ + "static/grhv-072fddfe399186489662769aea49a3b9.png";